// PageNumberButton.tsx
import classNames from "classnames";
import React from "react";
import Button from "../../Button";

const PageNumberButton = ({ pageNumber, currentPage, onClick }) => {
  return (
    <Button
      size="small"
      type={currentPage === pageNumber ? "primary" : "outline"}
      onClick={() => onClick(pageNumber)}
      className={classNames(
        "relative inline-flex items-center p-1 min-w-[28px] h-[28px] justify-center text-sm font-medium text-black rounded-full border-primary"
      )}
    >
      {pageNumber}
    </Button>
  );
};

export default PageNumberButton;
